import { autoinject, PLATFORM } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { isNullOrUndefined } from 'app/shared/lib/utilities';
import { IModalData, openGlobalModal, IDialogOptions } from 'app/shared/elements/ess-global-modal';

interface ICorrespondenceHistoryModalData {
    authId: string;
    authNumber: string;
    readonly?: boolean;
}

@autoinject()
export class CorrespondenceHistory extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected authId: string | undefined;
    protected authNumber: string | undefined;
    protected readonly: boolean = false;


    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
        this.logger.source = this;
    }
    protected async activate(modal: ICorrespondenceHistoryModalData): Promise<void> {
        if(!modal) { return; }

        if(!isNullOrUndefined(modal.authId)) {
            this.authId = modal.authId;
        }

        if(!isNullOrUndefined(modal.authNumber)) {
            this.authNumber = modal.authNumber;
        }

        if(!isNullOrUndefined(modal.readonly)) {
            this.readonly = !!modal.readonly;
        }
    }



    ////****************** Events ***************************************************////

    ////****************** Functions ************************************************////

    ////****************** Service Calls ********************************************////


}

/**
* Opens the correspondence history modal with the global dialog
*/
export function openCorrespondenceHistory(authId: string, authNumber: string, readonly: boolean = false): void {

    const dialogOptions: IDialogOptions = {
        width: '10',
        height: '10',
        helpTopic: 'pp.view-correspondence',
        title: {
            key: 'cd:routes.correspondence.history.$title',
            replace: { display: authNumber }
        },
        print: false
    };
    const historyModalData: ICorrespondenceHistoryModalData = {
        authId: authId,
        authNumber: authNumber,
        readonly: readonly
    };

    const modalData: IModalData = {
        componentId: PLATFORM.moduleName('app/pp/components/correspondence/correspondence-history'),
        modelData: historyModalData,
        dialogOptions: dialogOptions
    };

    openGlobalModal(modalData);
}

